import { Link } from '@remix-run/react'
import { cn } from '#app/utils/tailwind-merge.js'

const Logo = ({ className }: { className?: string }) => {
	return (
		<Link
			to="/"
			className={cn(
				'flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.18em] text-navy',
				className,
			)}
		>
			<img
				src="/img/workshop/mark.png"
				alt=""
				className="h-8 w-8 object-contain"
			/>
			Your AI
		</Link>
	)
}
export { Logo }
